import { isNative } from "@/lib/native";
import { useAuth } from "@/context/AuthContext";
import { Crown } from "lucide-react";
import SiteMenu from "@/components/SiteMenu";

export default function Header({ onSubscribe, wide }) {
  const { user } = useAuth();
  return (
    <header
      data-testid="app-header"
      className={`sticky top-0 z-40 safe-top box-content h-16 backdrop-blur-xl bg-[#04060B]/85 border-b border-[#D4AF37]/20 px-4 flex items-center justify-between ${wide ? "lg:px-10" : ""}`}
    >
      <div data-testid="brand-logo" className="flex items-center gap-2">
        <SiteMenu />
        <img src="/astra-mark-128.png" alt="" aria-hidden="true" className="w-9 h-9" />
        <span className="font-display text-xl tracking-[0.3em] text-starlight">ASTRA</span>
      </div>
      <div className="flex items-center gap-3">
        {user?.is_premium ? (
          <span className="flex items-center gap-1 text-[11px] uppercase tracking-wider gold-text">
            <Crown size={14} /> Premium
          </span>
        ) : isNative ? null : (
          <button
            data-testid="btn-subscribe-header"
            onClick={onSubscribe}
            className="text-[11px] uppercase tracking-wider text-[#04060B] bg-[#D4AF37] hover:bg-[#e6c04e] px-4 py-2.5 rounded-full transition-colors"
          >
            Subscribe
          </button>
        )}
      </div>
    </header>
  );
}
